import {
  ShowProps,
  SimpleShowLayout,
  TextField,
  ReferenceField,
  DateField,
  BooleanField,
} from "react-admin";
import { RESOURCE_NAME_ACCOUNT } from "../../../lib/modules/accounts";
import { DefaultShow } from "../../../lib/components";
import { COMMON_DATE_TIME_FORMAT } from "../../../lib/core";

const CurrencyShow= (props:ShowProps) => {
  return (
    <DefaultShow {...props}>
      <SimpleShowLayout>
        <TextField source="name" />
        <TextField source="description" />
        <TextField source="symbol" />
        <TextField source="label" />
        <ReferenceField source="accountId" reference={RESOURCE_NAME_ACCOUNT}>
          <TextField source="displayLabel" />
        </ReferenceField>
        <DateField source="createdAt" options={COMMON_DATE_TIME_FORMAT} />
        <DateField source="updatedAt" options={COMMON_DATE_TIME_FORMAT} />
        <TextField source="version" />
        <BooleanField source="isActive" />
        <BooleanField source="isBootstrapped" />
      </SimpleShowLayout>
    </DefaultShow>
  );
};

export { CurrencyShow };
